import Image from '../../assets/img/blog/blog-1.jpg';

const SingleBlog = (props) => {
  const {
    blogImg,
    blogClass,
    categoryClass,
    titleClass,
    btnClass,
    Title,
    Description,
    blogCategory,
    blogAuthor,
    publishedDate,
    btnText,
  } = props;
  return (
    <div className={blogClass ? blogClass : 'blog__item'}>
      <div className="blog__main-img fix">
        <img src={blogImg ? blogImg : Image} alt="" />
      </div>
      <div className="blog__content">
        <div className="blog__text">
          <h4
            className={
              titleClass ? titleClass : 'blog__title blog__title-color-1'
            }
          >
            {Title
              ? Title
              : 'Denizcilik Teknolojilerinde Yenilikçi Çözümler'}
          </h4>
          <p>
            {Description
              ? Description
              : 'Denizcilik teknolojileri kapsamında gemiler için entegre sistemlerin geliştirilmesi ve taşımacılığı kolaylaştıracak yenilikçi çözümler üretiyoruz.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SingleBlog;
